export { FAQRoute } from './constants';
export { FaqComponent } from './faq.component';